"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatTypes = void 0;
exports.FormatTypes = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
//# sourceMappingURL=Format.js.map